import { render, staticRenderFns } from "./ItemWriteAutoLayout.vue?vue&type=template&id=324843de&scoped=true&"
import script from "./ItemWriteAutoLayout.vue?vue&type=script&lang=js&"
export * from "./ItemWriteAutoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324843de",
  null
  
)

export default component.exports